import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "cart-widget__overview",
  ref: "root"
}
const _hoisted_2 = { class: "cart-widget__overview__table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, " Gesamt pro Monat ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, " Gesamt pro Jahr ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-outline-white w-100" }, " Zur Kasse ", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", null, _toDisplayString(_ctx.totalPerMonth) + " € ", 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, _toDisplayString(_ctx.totalPerYear) + " € ", 1)
        ])
      ]),
      (!_ctx.buttonDisabled)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["cart-widget__overview__entry", { 'inactive': _ctx.isOrderPage }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoOrder && _ctx.gotoOrder(...args)))
          }, _hoisted_6, 2))
        : _createCommentVNode("", true)
    ])
  ], 512))
}